import { render, staticRenderFns } from "./K3Upload.vue?vue&type=template&id=881a5b06&"
import script from "./K3Upload.vue?vue&type=script&lang=js&"
export * from "./K3Upload.vue?vue&type=script&lang=js&"
import style0 from "./K3Upload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports